import { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {useQuery} from "@tanstack/react-query";
import {getProjects} from "../services/newApi";
import {generateDateFinancementTexte} from "../pages/Home/functions/projectCardFunctions";
import Loader from "./Loader";
import ErrorWrapper from "./ui/wrappers/ErrorWrapper";

import {useLocation, useNavigate} from "react-router-dom";

const placeholder = "/images/projets/placeholder-projet.jpg";

const isNonEmptyString = (value) => typeof value === "string" && value.trim() !== "" && value !== "null" && value !== "undefined";

const getInitialImgSrc = (project) => {
    if (isNonEmptyString(project?.PhotosLocal) && project?.ProjetId) {
        return `/images/projets/${project.ProjetId}/${project.PhotosLocal}`;
    }

    if (isNonEmptyString(project?.Photo)) {
        return project.Photo;
    }

    return placeholder;
};

const CarouselSlide = ({ project, index, isEmprunteur, onClick }) => {
    const [imgSrc, setImgSrc] = useState(() => getInitialImgSrc(project));
    const [hasFailed, setHasFailed] = useState(false);

    useEffect(() => {
        setImgSrc(getInitialImgSrc(project));
        setHasFailed(false);
    }, [project?.ProjetId, project?.PhotosLocal, project?.Photo]);

    const handleError = () => {
        if (imgSrc === placeholder) return;

        if (!hasFailed && isNonEmptyString(project?.Photo) && imgSrc !== project.Photo) {
            setHasFailed(true);
            setImgSrc(project.Photo);
        } else {
            setImgSrc(placeholder);
        }
    };

    return (
        <div
            className="relative h-80 cursor-pointer hover:opacity-85"
            onClick={onClick}
        >
            <img
                className="h-full w-full object-cover rounded-lg"
                src={imgSrc}
                onError={handleError}
                alt={`Slide ${index}`}
            />
            <div className="absolute inset-0 bg-green-600 bg-opacity-10">
                <div className="flex justify-between p-2">
                    <div className={isEmprunteur ? "bg-white text-primary font-semibold px-2 py-1 rounded" : "bg-white text-secondary font-semibold px-2 py-1 rounded"}>
                        <span className="uppercase">{project.NomProjet}</span>
                        {generateDateFinancementTexte(project.FinCollecte)}
                    </div>
                    <div className="bg-white text-green-700 font-bold px-2 py-1 rounded">
                        Collecte Réussie
                    </div>
                </div>
            </div>
            <span className={isEmprunteur ? "absolute bottom-7 left-1/2 -translate-x-1/2 bg-primary text-white rounded-lg text-center px-3 py-2 text-lg" : "absolute bottom-7 left-1/2 -translate-x-1/2 bg-secondary text-white rounded-lg text-center px-3 py-2 text-lg"}>
                Voir nos opportunités
            </span>
        </div>
    );
};

const Carousel = () => {
    const {
        isPending,
        data: projects,
        error,
        isError
    } = useQuery({
        queryKey: ["project-finished-10"],
        queryFn: async () => getProjects("finished", 10),
    });
    const navigate = useNavigate();
    const location = useLocation();
    const isEmprunteur = location.pathname.startsWith('/emprunteur');

    const settings = {
        dots: false,
        fade: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
    };

    if (isPending) {
        return (<Loader />)
    }

    if (isError) {
        return <ErrorWrapper error={error.message} />
    }

    if (navigator.userAgent === 'ReactSnap') {
        return null;
    }

    return (
        <div className="w-full h-full">
            <Slider {...settings} className="overflow-hidden">
                {projects && projects.map((project, index) => (
                    <CarouselSlide
                        key={project?.ProjetId ?? index}
                        project={project}
                        index={index}
                        isEmprunteur={isEmprunteur}
                        onClick={() => {navigate("/inscription/preteur")}}
                    />
                ))}
            </Slider>
        </div>
    );
}

export default Carousel;